import axios from 'axios';

const api = axios.create({
    baseURL: 'https://api.muharrammelodies.ir/api/v1/',
    headers: {
        "Content-Type": "application/json",
        "X-Client-Version": 1
    }
});

// Add a request interceptor to include the bearer token
api.interceptors.request.use(config => {
    const token = localStorage.getItem('Token');
    if (token) {
        config.headers['Authorization'] = `Bearer ${JSON.parse(token)}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

export default api;
